module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-tag-container",
    class: {
      'living-tag-container': _vm.type === '1'
    }
  }, [_c('img', {
    staticClass: "icon-play",
    attrs: {
      "src": _vm.activeTag.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-text"
  }, [_vm._v(_vm._s(_vm.activeTag.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310d2b2e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMatchTag.vue
// module id = 607
// module chunks = 1 3